//   SCA colors
const colors = {
  //   Green colors: G1, G2, G3, G3-1, G3-2, G3-3, G3-4, ok with dark text
  //   Green colors:         G3, G3-1, G3-2, G4, G5, G5-1, G5-2 ok with white text
  'G1': '#DEEDE4',
  'G2': '#8FC1A6',
  'G3-4': '#57BC82',
  'G3-3': '#4EA875',
  'G3': '#44986B',
  'G3-2': '#3D845C',
  'G3-1': '#367551',

  'G4': '#587370',
  'G5': '#2D4440',
  'G5-2': '#1D3D3B',
  'G5-1': '#10211F',

  //   Wood colors: ok with dark text colors, only T3 acceptable with light text color
  'T1': '#F9F0E4',
  'T2': '#CCA38E',
  'T3': '#AA6543',

  //   Blue colors: ok with white and G2, G3, G3-2, G3-3, G3-4, text colors
  'B1': '#00205B',

  //   Neutral colors: N1, N2 ok with dark text, N2, N3 ok with white text
  'N1': '#E6EAE9',
  'N2': '#696969',
  'N3': '#262626',
  'S': '#000000',
  'V': '#FFFFFF',
};

const projectIconColors = [
  '#696969',
  '#798f8c',
  '#85C1A6',
  '#44986B',
  '#587370',
  '#70938E',
  '#CCA38E',
  '#AA6543',
  '#367551',
  '#78A893',
  '#42855F',
  '#4E6562',
  '#64817D',
  '#B18F7E',
  '#93593E',
  '#346648',
];

export { colors, projectIconColors };



// WEBPACK FOOTER //
// ../common/colors.ts